var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDropdownLogout = function SvgDropdownLogout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m1.477 4.931 6.256-2.998a.69.69 0 0 1 1.042.592v.9h4.654c.38 0 .688.308.688.689v2.868c0 .906-1.377.906-1.377 0v-2.18H8.775v10.401h3.965v-2.18c0-.905 1.377-.905 1.377 0v2.869c0 .38-.308.688-.688.688H8.775l-.003.9a.686.686 0 0 1-.981.62L1.534 15.1a.69.69 0 0 1-.45-.646l.003-8.905c0-.256.144-.501.39-.619m9.385 4.2c-1.146 0-1.146 1.742 0 1.742h5.084l-.987.986c-.81.81.422 2.041 1.232 1.232l2.468-2.469a.871.871 0 0 0 0-1.241l-2.468-2.469c-.81-.81-2.042.422-1.232 1.232l.987.986z",
    clipRule: "evenodd"
  })));
};
export default SvgDropdownLogout;